import { resetCookieConsentValue } from "react-cookie-consent";

export const AERA_COOKIE_CONSENT_NAME = "aera-cookie-consent";

export const AERA_COOKIE_CONSENT_OPEN_EVENT = "aera:cookie-consent-open";

/** ลบคุกกี้ความยินยอมแล้วเปิดแบนเนอร์ใหม่ (ใช้จากเมนู/ฟุตเตอร์ "จัดการคุกกี้") */
export function openCookieConsentBanner(): void {
  if (typeof window === "undefined") return;
  resetCookieConsentValue(AERA_COOKIE_CONSENT_NAME);
  window.dispatchEvent(new CustomEvent(AERA_COOKIE_CONSENT_OPEN_EVENT));
}
